import CurrencyCellHtml         from '../../app-lite/grids/templates/cell.currency.html';
import EditableCellHtml         from '../../app-lite/grids/templates/cell.editable.html';
import EditableCurrencyCellHtml from '../../app-lite/grids/templates/cell.currency.editable.html';
import PaymentMethodCellHtml    from './templates/customer-cash-payment.payment-method.cell.html';
import RemoveRowCellHtml        from '../../app-lite/grids/templates/cell.remove-row.html';

export function CashPaymentCtrl (
  $q,
  $rootScope,
  $scope,
  $state,
  $timeout,
  $translate,
  $uibModalInstance,
  assemblyPaymentsApi,
  blockUI,
  Celero,
  customer,
  customerPaymentApi,
  integrations,
  invoice,
  Invoice,
  isRefund,
  messages,
  methods,
  onlinePaymentsApi,
  tillpaymentsApi,
  terminalId,
  workshopAPI
) {

  $scope.balance         = '0';
  $scope.block           = blockUI.instances.get('cashPaymentBlock');
  $scope.celero          = new Celero();
  $scope.customer        = customer;
  $scope.integrations    = integrations;
  $scope.invoice         = invoice;
  $scope.invoiceApi      = new Invoice(invoice);
  $scope.isRefund        = isRefund;
  $scope.isEftPosUsed    = false;
  $scope.payment         = {};
  $scope.paymentMethods  = methods;
  $scope.terminals       = [];

  $scope.terminal = {
    terminalId
  };

  $scope.fields = {
    items: $scope.isRefund
    ? 'customer_refund_items_attributes'
    : 'customer_payment_items_attributes',
    paymentMethods: $scope.isRefund
    ? 'customer_refund_methods_attributes'
    : 'customer_payment_methods_attributes'
  };

  $scope.grid = {
    columnDefs: [
      {
        cellTemplate  : RemoveRowCellHtml,
        enableCellEdit: false,
        width         : '43px'
      },
      {
        cellFilter          : 'customerPaymentMethod:paymentMethods',
        displayName         : $translate.instant('GENERAL_SPACE.FIELD.PAYMENT_METHOD'),
        editableCellTemplate: PaymentMethodCellHtml,
        field               : 'customer_payment_method',
        handleChange        : ( row, col ) => {
          const method = $scope.paymentMethods.filter(( paymentMethod = {} ) => paymentMethod.id === row.entity.customer_payment_method)[0];

          $scope.isEftPosUsed = method.use_eftpos;

          row.entity.payment_type = method.payment_method;
          row.entity.use_eftpos   = method.use_eftpos;

          if ($scope.isEftPosUsed && $rootScope.Company.hasIntegration('tillpayments-pos')) {
            $scope.block.start();

            tillpaymentsApi.getTerminals()
            .then(terminals => {
              $scope.terminals = terminals;

              if ($scope.terminal.terminalId) {
                $scope.setDefaultTerminal();
              }
            })
            .catch(err => {
              messages.error(err);
            })
            .finally(() => {
              $scope.block.stop();
            });
          }
        }
      },
      {
        displayName         : $translate.instant('GENERAL_SPACE.FIELD.REFERENCE'),
        editableCellTemplate: EditableCellHtml,
        field               : 'reference'
      },
      {
        cellClass           : 'align-right',
        cellFilter          : 'globalCurrency',
        cellTemplate        : CurrencyCellHtml,
        displayName         : $translate.instant('JS_SPACE.COLUMNS.AMOUNT'),
        editableCellTemplate: EditableCurrencyCellHtml,
        field               : 'amount',
        width               : '101px'
      }
    ],
    data                   : `payment['${ $scope.fields.paymentMethods }']`,
    enableCellEditOnFocus  : true,
    enableCellSelection    : true,
    enableMultiSelect      : false,
    enableRowSelection     : false,
    rowHeight              : 43,
    virtualizationThreshold: 9999
  };

  $scope.addItem = function () {
    $scope.payment[ $scope.fields.paymentMethods ].push({
      amount                 : '0.00',
      customer_payment_method: null,
      payment_type           : '',
      use_eftpos             : false
    });
  };

  $scope.allowManualCardPayment = function () {
    return !$scope.isRefund
      && $rootScope.Company.hasIntegration('celero')
      && $scope.celero.hasApiKey()
      && $scope.celero.hasPublicKey();
  };

  $scope.enterCardManually = function () {
    $scope.validate()
    .then(() => $scope.savePayment())
    .then(payment => {
      $scope.payment = payment;

      return $scope.celero.enterCardManually($scope.invoice, $scope.payment);
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.PROCESSED.PAYMENT'),'success');

      $uibModalInstance.close($scope.invoice);
    }).catch(error => {
      messages.error(error);
    });
  };

  $scope.getTotals = function () {
    var totals = {
      balance: new BigDecimal($scope.invoice.balance_due.toString()),
      cash   : BigDecimal.ZERO,
      nonCash: BigDecimal.ZERO,
      total  : BigDecimal.ZERO
    };

    angular.forEach($scope.payment[ $scope.fields.paymentMethods ], method => {
      const amount = new BigDecimal(method.amount.toString());

      if (method.payment_type.toLowerCase() === 'cash') {
        totals.cash = totals.cash.add(amount);
      }

      totals.total = totals.total.add(amount);
    });

    totals.nonCash = totals.total.subtract(totals.cash);

    return totals;
  };

  $scope.handleTerminalSelection = function () {
    $scope.block.start();

    $scope.terminal = $scope.terminals.filter(terminal => terminal.terminalId === $scope.terminal.terminalId)[0];

    tillpaymentsApi.saveDefaultUserTerminal($scope.terminal)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.TILLPAYMENTS.USER_PREFERENCE_UPDATED'), 'success');

      $scope.setDefaultTerminal();
    })
    .catch(err => {
      messages.error($translate.instant('USER_PREFERENCE_NOT_UPDATED'));

      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.hasPaymentIntegration = function () {
    return ( $rootScope.Company.hasIntegration('celero') && $scope.celero.hasApiKey() )
      || $rootScope.Company.hasOnlinePayments();
  };

  $scope.prepPayment = function () {
    $scope.payment = {
      amount        : $scope.invoice.balance_due,
      applied_amount: $scope.invoice.balance_due,
      customer_id   : $scope.customer.id,
      post_date     : $scope.invoice.post_date
    };

    $scope.payment[ $scope.fields.items ] = [{
      amount             : $scope.invoice.balance_due,
      invoice_balance_due: $scope.invoice.balance_due,
      invoice_id         : $scope.invoice.id,
      invoice_number     : $scope.invoice.invoice_number,
      invoice_post_date  : $scope.invoice.post_date,
      invoice_total      : $scope.invoice.total
    }];

    $scope.payment[ $scope.fields.paymentMethods ] = [{
      amount                 : $scope.invoice.invoice_type === 'C' ? $scope.invoice.total : $scope.invoice.balance_due,
      customer_payment_method: $scope.paymentMethods[0].id,
      payment_type           : $scope.paymentMethods[0].payment_method,
      use_eftpos             : $scope.paymentMethods[0].use_eftpos
    }];
  };

  $scope.process = function () {
    $scope.block.start();

    return $scope.validate()
    .then(() => $scope.savePayment())
    .then(payment => {
      const url = $scope.isRefund
        ? '/invoice/process_refund'
        : '/customer_payments/process_payment';

      $scope.payment = payment;

      if ($rootScope.Company.hasPOS()) {
        const amount = customerPaymentApi.getPosPaymentTotal($scope.payment, $scope.isRefund);

        if (amount) {
          if ($rootScope.Company.hasIntegration('tillpayments-pos')) {
            const type = $scope.isRefund ? 'refund' : 'payment';

            return $timeout(() => tillpaymentsApi.processTransaction(
              $scope.payment,
              amount,
              type,
              $scope.terminal,
              $scope.invoice
            ));
          }

          return $rootScope.Company.hasIntegration('assembly-payments')
            ? assemblyPaymentsApi.processPayment($scope.payment, $scope.invoice, amount, $scope.isRefund)
            : ( $scope.isRefund
              ? $q.reject('Assembly Payments not setup properly')
              : $scope.processCelero(amount)
            );
        }
      }

      return workshopAPI.get(url, payment.id
          ? payment.id
          : $scope.invoice.id
        );
    })
    .then(() => {
      messages.show($translate.instant($scope.isRefund
        ? 'JS_SPACE.MESSAGES.INVOICE_REFUNDED'
        : 'JS_SPACE.MESSAGES.PROCESSED.PAYMENT'
      ),'success');

      $uibModalInstance.close($scope.invoice);
    })
    .catch(err => {
      messages.error(err);

      if (!$scope.isRefund && $scope.payment.id) {
        $uibModalInstance.dismiss();

        $state.go('app.customer-payment', {
          customer_id: $scope.payment.customer_id,
          id         : $scope.payment.id
        });
      }
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.processCelero = function (amount) {
    return $q.when().then(() => {
      return $scope.celero.hasMultipleTerminals() ?
        $scope.celero.chooseTerminal() :
        $q.when({});
    })
    .then((terminal = {}) => {
      return $scope.celero.process({
        amount,
        invoice_id : $scope.invoice.id,
        payment_id : $scope.payment.id,
        terminal_id: terminal.id
      });
    });
  };

  $scope.removeItem = function (row) {
    $scope.payment[ $scope.fields.paymentMethods ].splice(row.rowIndex, 1);

    $scope.updateTotals();
  };

  $scope.savePayment = function () {
    const method = $scope.payment.id ? 'patch' : 'post';
    const url    = $scope.payment.id ? 'customer_payment' : 'customer_payments';

    return $scope.isRefund
      ? $q.when($scope.payment)
      : workshopAPI[method](url, $scope.payment, 'customer_payment');
  };

  $scope.savePrintType = function () {
    localStorage.setItem('invoicePrintCashSwitch', angular.toJson($scope.invoice.printType));
  };

  $scope.sendPaymentRequest = function (via = 'email') {
    if ($rootScope.Company.hasOnlinePayments()) {
      $q.when()
      .then(() => {
        return via === 'sms'
          ? onlinePaymentsApi.requestSmsPayment($scope.invoice, $scope.customer)
          : $scope.invoiceApi.email($scope.invoice, {
            customer      : $scope.customer,
            requestPayment: true,
            sendInvoice   : true,
          });
      })
      .then(() => {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SENT.PAYMENT_REQUEST'), 'success');

        $uibModalInstance.close($scope.invoice);
      })
      .catch(err => {
        messages.error(err);
      });
    }
    else if ($rootScope.Company.hasIntegration('celero')) {
      workshopAPI.get('/transnational_payments/send_payment_to_customer', $scope.invoice.id)
      .then((response) => {
        if (response.success) {
          messages.show('Celero Invoice URL sent by Email to customer. Payment cancelled.', 'success');

          $uibModalInstance.close($scope.invoice);
        }
        else {
          return $q.reject(response.error);
        }
      })
      .catch(error => {
        messages.error(error);
      });
    }
  };

  $scope.sendRefundRequest = function () {
    if ( $rootScope.Company.hasIntegration('tillpayments-online') ) {
      workshopAPI.post('/tillpayments/tillpayments_online_payment_reversal', { invoice_id: $scope.invoice.id })
      .then(() => {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SENT.REFUND_REQUEST'), 'success');

        $uibModalInstance.close($scope.invoice);
      })
      .catch(err => {
        messages.error(err);
      });
    }
    else {
      messages.error('Online Payments not setup properly');
    }
  };

  $scope.setDefaultTerminal = function () {
    /**
     * Sometimes an old, inactive terminal has been
     * saved by the user so a match won't be found.
     * To avoid binding issues in the terminal dropdown,
     * we make sure if there is no match to set the
     * terminal to an empty object so the selected ID
     * can be set properly.
     *
     * REFERENCE: WS-5326
     */
    $scope.terminal = $scope.terminals.filter(terminal =>
      terminal.terminalId === $scope.terminal.terminalId
    )[0] || {};
  };

  $scope.updateTotals = function () {
    const totals = $scope.getTotals();

    $scope.excessBalance = false;

    // Cant have change with non cash methods, so set the error flag
    if (totals.nonCash.isGreaterThan(totals.balance)) {
      $scope.balance       = totals.balance.subtract(totals.total).toString();
      $scope.cashBack      = BigDecimal.ZERO.toString();
      $scope.excessBalance = true;
    }

    // If payment amounts are still higher than balance, then there is extra cash and change needs to be calculated
    else if (totals.total.isGreaterThan(totals.balance)) {
      $scope.balance  = BigDecimal.ZERO.toString();
      $scope.cashBack = totals.balance.subtract(totals.total).abs().toString();
    }

    // Either payment matches balance exactly or payment is less. Insufficient payment doesn't get validated until save
    else {
      $scope.balance  = totals.balance.subtract(totals.total).toString();
      $scope.cashBack = BigDecimal.ZERO.toString();
    }

    // if the invoice is of type credit, reflect
    // the proper balance.
    if ($scope.invoice.invoice_type === 'C') {
      $scope.invoice.balance_due = $scope.invoice.total;
    }
  };

  $scope.validate = function () {
    const cashBack = new BigDecimal($scope.cashBack);
    const totals   = $scope.getTotals();

    let cashMethods    = [];
    let combinedCashes = {};

    // If the payments dont add up to the balance on the invoice, fail.
    if (totals.total.isLessThan(totals.balance)) {
      return $q.reject($translate.instant('JS_SPACE.MESSAGES.PAYMENT_IS_INSUFFICIENT'));
    }

    // If the non cash amount exceeds the balance of the invoice, fail.
    else if (totals.nonCash.isGreaterThan(totals.balance)) {
      return $q.reject($translate.instant('JS_SPACE.MESSAGES.PAYMENT_EXCEEDS_BALANCE'));
    }

    // If there is cashback, we need to remove it from the object being sent to the server,
    else if (!cashBack.isZero()) {
      cashMethods = $scope.payment[ $scope.fields.paymentMethods ].filter(method => method.payment_type.toLowerCase() === 'cash');

      // If there are multiple line items that are cash, combine them.
      if (cashMethods.length > 1) {
        $scope.payment[ $scope.fields.paymentMethods ] = $scope.payment[ $scope.fields.paymentMethods ].filter(method => method.payment_type.toLowerCase() !== 'cash');

        combinedCashes = cashMethods[0];

        // Set the amount to the proper amount without cash back.
        combinedCashes.amount = totals.cash.subtract(cashBack).toString();

        $scope.payment[ $scope.fields.paymentMethods ].push(combinedCashes);
      }
      else {
        cashMethods[0].amount = totals.cash.subtract(cashBack).toString();
      }
    }

    /**
     * Sync items[0].amount to the actual settled total when a single invoice is being paid.
     *
     * WHY?
     *
     * items.amount is prefilled to invoice.balance_due in prepPayment but never updated
     * when the user changes method amounts, so BE was persisting a stale balance over what
     * the user actually paid (e.g. $1510 prefill vs $1500 typed).
     */
    if ( $scope.payment[ $scope.fields.items ].length === 1 ) {
      const settledTotal = totals.cash.add(totals.nonCash).subtract(cashBack);

      $scope.payment[ $scope.fields.items ][0].amount = settledTotal.toString();

      $scope.payment.amount = settledTotal.toString();
    }

    return $q.when(true);
  };

  $scope.$watch(`payment['${ $scope.fields.paymentMethods }']`, items => {
    if (!items.length) {
      $scope.addItem();
    }
    else {
      $scope.updateTotals();
    }
  }, true);

  $scope.prepPayment();
}
